<template>
    <div id="responseAssociationModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="responseAssociationTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="responseAssociationTitle">Link Response</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body">
                    <h5 v-if="document">{{ document.description }}</h5>
                    <div class="d-flex justify-content-between">
                        <div class="mt-auto font-smaller font-weight-bold">Submitted Documents:</div>
                        <div class="w-50">
                            <div class="input-group input-group-sm mb-1 mr-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text"><i class="fas fa-search fa-sm text-muted"></i></div>
                                </div>
                                <input type="text" class="form-control" placeholder="Search Descriptions" v-model="searchString">
                            </div>
                        </div>                        
                    </div>
                    <div>
                        <table class="table table-sm font-smaller mb-3">
                            <thead>
                                <tr>
                                    <th>Document</th>
                                    <th class="fit">Submitted</th>
                                    <th v-if="responseVisible" class="fit">Response</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="filteredDocuments.length">
                                    <tr v-for="doc in filteredDocuments" :key="'submitted-document-' + doc.id">
                                        <td class="checkbox-position">
                                            <div class="custom-control custom-checkbox align-center">
                                                <input :id="'response-document-checkbox-' + doc.id" type="checkbox" class="custom-control-input" v-model="doc.selected">
                                                <label class="custom-control-label pt-1" :for="'response-document-checkbox-' + doc.id" :title="doc.document_type_name + ' - ' + doc.description">
                                                    {{ doc.document_type.name }} - {{ doc.description | truncate(55) }}
                                                </label>
                                            </div>                                        
                                        </td>
                                        <td class="fit pt-3">{{ doc.submitted_at | localizeTime('YYYY-MM-DD HH:mm:ss')  }}</td>
                                        <td v-if="responseVisible" class="fit text-center">
                                            <div v-if="doc.document_type_id == DocumentType.LWC_FORM_1010" class="btn-group dropdown">
                                                <button type="button" class="btn btn-sm btn-default dropdown-toggle" data-toggle="dropdown" :disabled="!doc.selected">
                                                    <i v-if="doc.document_status_id == DocumentStatus.AUTHORIZATION_APPROVED" class="fas fa-lg fa-thumbs-up text-success"></i>
                                                    <i v-else-if="doc.document_status_id == DocumentStatus.AUTHORIZATION_APPROVED_WITH_MODIFICATIONS" class="fas fa-lg fa-thumbs-up text-secondary"></i>
                                                    <i v-else-if="doc.document_status_id == DocumentStatus.AUTHORIZATION_DENIED" class="fas fa-lg fa-thumbs-down text-danger"></i>                                 
                                                    <i v-else class="far fa-lg fa-question-circle text-muted"></i>
                                                </button>
                                                <div class="dropdown-menu dropdown-menu-right font-smaller">
                                                    <a class="dropdown-item" @click="updateStatus(doc, null)"><i class="far fa-lg fa-question-circle text-muted"></i> No Response</a>
                                                    <div class="dropdown-divider"></div>                                                    
                                                    <a class="dropdown-item" @click="updateStatus(doc, DocumentStatus.AUTHORIZATION_APPROVED)"><i class="fas fa-lg fa-thumbs-up text-success"></i> Approved</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" @click="updateStatus(doc, DocumentStatus.AUTHORIZATION_APPROVED_WITH_MODIFICATIONS)"><i class="fas fa-lg fa-thumbs-up text-secondary"></i> Approved with Modifications</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" @click="updateStatus(doc, DocumentStatus.AUTHORIZATION_DENIED)"><i class="fas fa-lg fa-thumbs-down text-danger"></i> Denied</a>
                                                </div>                                                 
                                            </div>
                                            <div v-else-if="doc.document_type_id == DocumentType.LWC_FORM_1009" class="btn-group dropdown">
                                                <button type="button" class="btn btn-sm btn-default dropdown-toggle" data-toggle="dropdown" :disabled="!doc.selected">
                                                    <i v-if="doc.status == DocumentStatus.AUTHORIZATION_DISPUTE_APPROVED" class="fas fa-lg fa-thumbs-up text-success"></i>
                                                    <i v-else-if="doc.status == DocumentStatus.AUTHORIZATION_DISPUTE_DENIED" class="fas fa-lg fa-thumbs-down text-danger"></i>                                 
                                                    <i v-else class="far fa-lg fa-question-circle text-muted"></i>
                                                </button>
                                                <div class="dropdown-menu dropdown-menu-right font-smaller">
                                                    <a class="dropdown-item" @click="updateStatus(doc, null)"><i class="far fa-lg fa-question-circle text-muted"></i> No Response</a>
                                                    <div class="dropdown-divider"></div>                                                    
                                                    <a class="dropdown-item" @click="updateStatus(doc, DocumentStatus.AUTHORIZATION_DISPUTE_APPROVED)"><i class="fas fa-lg fa-thumbs-up text-success"></i> Approved</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a class="dropdown-item" @click="updateStatus(doc, DocumentStatus.AUTHORIZATION_DISPUTE_DENIED)"><i class="fas fa-lg fa-thumbs-down text-danger"></i> Denied</a>
                                                </div>                                                 
                                            </div>                                                                             
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr><td class="text-center text-muted" colspan="3"><h5>No Documents</h5></td></tr>
                                </template>
                            </tbody>
                        </table>
                    </div>                    
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" @click="associate()">Link</button>
                    <button class="btn btn-secondary" data-dismiss="modal">Close</button>                    
                </div>
            </div>
        </div>
    </div>                
</template>

<script>
import { DocumentType, DocumentStatus } from '../../constants.js';

export default {
    data() {
        return {

            // import constants into the template
            DocumentType: DocumentType,
            DocumentStatus: DocumentStatus,

            document: null,
            documents: [],
            searchString: ''
        }
    },
    computed: {
         filteredDocuments: function () {
            const self = this;
             return self.documents.filter(e => e.description.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1);
         },
         responseVisible: function () {
             return this.document && 
                (this.document.document_type_id == DocumentType.LWC_FORM_1010_RESPONSE ||
                 this.document.document_type_id == DocumentType.LWC_FORM_1010A ||
                 this.document.document_type_id == DocumentType.LWC_FORM_1009_RESPONSE);
         }
    }, 
    methods: {
        show: function (document) {

            this.document = document;
            axios.get('/ajax/responses/' + document.id + '/submissions')
                .then(response => {

                    let associations = response.data.associations;
                    this.documents = response.data.documents.map(e => { 
                        let isSelected = associations.includes(e.id);
                        this.$set(e, 'selected', isSelected); 
                        return e;
                    });

                    this.$nextTick(() => {
                        $('[data-toggle="popover"]').popover();                        
                    });

                    $('#responseAssociationModal').modal('show'); 
                })
                .catch(error => {
                    // TODO: handle errors
                    console.log(error);
                });
        },
        updateStatus: function (document, documentStatusId) {
            document.document_status_id = documentStatusId;
            this.$forceUpdate();
        },
        associate: function () {
            let documents = this.documents.map(e => ({
                id: e.id,
                document_status_id: e.document_status_id,
                selected: e.selected
            }));
            axios.post('/ajax/responses/' + this.document.id + '/associate', {
                documents: documents
            })
            .then(response => {

                $('#responseAssociationModal').modal('hide');
            })
            .catch(error => {

                // TODO: handle error
                console.log(error);
                $('#responseAssociationModal').modal('hide');
            });
        }
    },
    created() {
        eventHub.$on('show-response-association', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-response-association');
    }
}
</script>

<style scoped>
    .checkbox-position {
        padding-top: 12px;
    }
    
    .font-smaller {
        font-size: .75rem;
    }
</style>